document.addEventListener("DOMContentLoaded", (event) => {
  let productImagesDiv = document.getElementById("product-image-data");
  if (productImagesDiv) {
    let imagesArray = JSON.parse(productImagesDiv.getAttribute("data-images"));
    let section = document.getElementById(productImagesDiv.getAttribute('data-section-id'));


    
    document.addEventListener("variant:changed", function (e) {
      let variant = e.detail.variant;
      let variantOptions = variant.options.map((v) => v.toLowerCase());
      let imagesContainer = section.querySelectorAll(
        "product-media flickity-carousel .product__media-item"
      );



      let imagesThumbContainer = section.querySelector(
        "product-media .product__thumbnail-list-inner"
      );

      let flickityElement = section.querySelector('flickity-carousel[data-pdp]');

      let buttonThumbContainer = section.querySelector("product-media .dots-nav");

      //Loop all Metafield Arrays

      imagesArray.forEach((imageTags, arrayIndex) => {
        if (imageTags !== "all") {
          let show = true;
          let imageOptions = imageTags.split("_");
            imageOptions.forEach((imageOption, index) => {
              if(imageOption !== "all" && imageOption.toLowerCase() !== variantOptions[index]){
                show = false;
              }
            });  

          let productImage = section.querySelector(`[data-original-position="${arrayIndex}"]`);
          
          if(show){
          if(productImage){
            productImage.classList.remove('is-filtered');
          }
          imagesThumbContainer.children[arrayIndex].classList.remove('is-filtered');
          buttonThumbContainer.children[arrayIndex].classList.remove('is-filtered');
          }
          else{
            if(productImage){
            productImage.classList.add('is-filtered');
            }
           imagesThumbContainer.children[arrayIndex].classList.add('is-filtered');
          buttonThumbContainer.children[arrayIndex].classList.add('is-filtered');
          }

        }
      });
    });
  }
});
